import paymentSystemIcons from '~/shared/constants/paymentIcons';
import defaultIcon from '~/shared/legacy_res/img/svg/default.svg';
import {Card} from '../../../api/CardSchema';
import {CardListItemView, CardStatusView} from '../../uiSchemas';

const getCardStatus = (card: Card): CardStatusView => {
    if (card.verify_reason) {
        return {statusText: card.verify_reason, statusColor: 'danger'};
    }
    switch (card.status) {
        case 'not_verified':
            return {
                statusText: 'Need to verify',
                statusColor: 'danger',
            };

        case 'pending':
            return {
                statusText: 'On verification',
                statusColor: 'warning',
            };

        default:
            return {statusText: '', statusColor: 'default'};
    }
};

// TODO: change getting topupAction after refactoring on Finances reducer
export const cardsToView = (cards: Card[], isDisabled: boolean): CardListItemView[] => {
    return cards.map((card: Card) => {
        return {
            ...getCardStatus(card),
            id: card.id,
            title: card.title,
            iconSrc: paymentSystemIcons[card.type] ?? defaultIcon,
            isDisabled,
            needToVerify: card.status === 'not_verified',
        };
    });
};
